<template>
  <div class="module-setting">
    <a-tree
      checkable
      v-model="checked"
      :default-expanded-keys="expandKeys"
      @check="onCheck"
      :tree-data="moduleList"
    />
  </div>
</template>

<script>
    import { moduleList } from "../permission/module";

    export default {
        name: "module-setting",
        model: {
            event: "change"
        },
        props: {
            value: Array
        },
        data() {
            return {
                moduleList,
                expandKeys: moduleList.filter(m => m.children && m.children.length > 0).map(m => m.key),
                checked: []
            }
        },
        watch: {
            value() {
                this.setChecked();
            }
        },
        created() {
            this.setChecked();
        },
        methods: {
            setChecked() {
                const value = this.value;
                if(value) {
                    this.checked = [...value];
                } else {
                    this.checked = [];
                }
            },
            onCheck() {
                const checked = this.checked;
                this.$emit("change", checked && checked.length > 0 ? [...checked] : null)
            }
        }
    }
</script>

<style scoped>

</style>
